export default "__VITE_ASSET__df9efa7b__"